import { UIView } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";

export const ALERTS_SCROLL_CONTAINER_ID = "alerts-scroll-container";

export const AlertsRootContainer = () => {
    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <div
                className="sw-layout-module-inner sw-layout-scrollable-element main-homepage-container"
                id={ALERTS_SCROLL_CONTAINER_ID}
            >
                <UIView />
            </div>
        </ErrorBoundary>
    );
};
